import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Filter } from '../models/filter-models';
import { CustomTieringModeDialogComponent } from '../common/custom-tiering-mode-dialog/custom-tiering-mode-dialog.component';

@Component({
  selector: 'app-custom-currency-tiering-mode-dialog',
  imports: [CustomTieringModeDialogComponent],
  template: `<app-custom-tiering-mode-dialog kind="currency" [filter]="filter" (close)="close.emit()" />`,
})
export class CustomCurrencyTieringModeDialogComponent {
  @Input({ required: true }) filter!: Filter;
  @Output() close = new EventEmitter<void>();
}
